import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { loadNavPreferences } from './utils/navigate';
import './styles/global.css';

// Carica le preferenze navigatore (condivise sull'account) nella cache locale.
// Best-effort: in caso di errore restano i default e si riprovano in Impostazioni.
void loadNavPreferences().catch(() => {});

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);

// Service worker: serve a far aprire la livella in piazzola senza campo.
// Best-effort: senza, l'app funziona, semplicemente non offline.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/service-worker.js').catch(() => {});
  });
}
